import { StoryLoading } from "../basic/story-loading/story-loading";
import get from "lodash/get";
import { RequestMeteredSubsciption } from "../basic/request-subscription/request-metered-subscsription";
import { RequestSubscription } from "../basic/request-subscription/request-subscription";
import { StoryPageCard } from "../story-page-components/story-page-card";
import { DfpAd } from "../dfp-ad";
import React from "react";

async function getAccessData(checkAccess, story, accessUpdated, accessIsLoading, config) {
  const enableAccessType = get(config, ["theme-attributes", "enableAccesstype"]) === "true";
  const storyId = get(story, ["id"]);
  let access = {};

  if (enableAccessType && !checkIfStoryPublic(story)) {
    access = await checkAccess(storyId);
  } else {
    access = generateSubscribedAccess(storyId);
    const accessById = { [storyId]: access };
    if (typeof accessIsLoading === "function" && typeof accessUpdated === "function") {
      accessIsLoading(false);
      accessUpdated(accessById);
    }
  }

  return access;
}

function generateSubscribedAccess(storyId) {
  return { granted: true, grantReason: "SUBSCRIBER", data: {} };
}

function getIfAccessLoading(storyCards = [], story, cdnImage, getStoryCardTemplate, config) {
  const firstTwoCards = storyCards.slice(0, 2);
  return (
    <div>
      {getStoryCards(firstTwoCards, config, story, cdnImage, getStoryCardTemplate)}
      <StoryLoading />
    </div>
  );
}

function getIfHasAccess(storyCards, story, cdnImage, getStoryCardTemplate) {
  return getStoryCards(storyCards, story, cdnImage, getStoryCardTemplate);
}

function getIfMeteredAccess(storyCards, access, story, cdnImage, getStoryCardTemplate, config) {
  const firstCard = get(storyCards, [0], {});
  const accessData = get(access, ["data"], {});
  const disableMetering = get(config, ["theme-attributes", "disableMetering"]) === "true";
  if (!disableMetering || accessData.numberRemaining > -1) {
    return <div>{getStoryCards(storyCards, story, cdnImage, getStoryCardTemplate)}</div>;
  }

  return (
    <div>
      {getStoryCards([firstCard], story, cdnImage, getStoryCardTemplate, config)}
      <RequestMeteredSubsciption subscriptionCount={accessData.numberRemaining} />
    </div>
  );
}

function getIfNoAccess(storyCards, story, cdnImage, getStoryCardTemplate, config) {
  const firstCard = get(storyCards, [0], {});
  return (
    <div>
      {getStoryCards([firstCard], config, story, cdnImage, getStoryCardTemplate)}
      <RequestSubscription config={config} story={story} />
    </div>
  );
}

function getStoryCards(cards = [], story, cdnImage, getStoryCardTemplate) {
  if (typeof getStoryCardTemplate === "function") {
    return getStoryCardTemplate(cards);
  }

  const hasMultiCards = cards.length > 1;
  const storyCards = cards.map((card, index) => {
    if (index === 0 && hasMultiCards) {
      return (
        <div key={card.id} className="blank-story__card--with-ad">
          <StoryPageCard key={card.id} card={card} story={story} cdn={cdnImage} />
          <div className="app-ad app-ad--story-horizontal">
            <DfpAd adtype="Story-Middle-Ad" />
          </div>
        </div>
      );
    } else {
      return <StoryPageCard key={card.id} card={card} story={story} cdn={cdnImage} />;
    }
  });
  return <div>{storyCards}</div>;
}

function handleAccess(story, storyAccess, accessLoading, config, storyCardTemplate) {
  const storyId = get(story, ["id"]);
  const access = get(storyAccess, [storyId]);
  const granted = get(access, ["granted"], false);
  const storyCards = get(story, ["cards"], []);
  const cdnImage = get(config, ["cdn-image"], "");

  if (accessLoading) {
    return getIfAccessLoading(storyCards, story, cdnImage, storyCardTemplate, config);
  }

  if (granted && access && !accessLoading) {
    const grantReason = get(access, ["grantReason"]);

    switch (grantReason) {
      case "METERING":
        return getIfMeteredAccess(storyCards, access, story, cdnImage, storyCardTemplate, config);
      case "SUBSCRIBER":
        return getIfHasAccess(storyCards, story, cdnImage, storyCardTemplate);
    }
  }

  return getIfNoAccess(storyCards, story, cdnImage, storyCardTemplate, config);
}

function checkIfStoryPublic(story) {
  const access = get(story, ["access"]);
  return access === "public" || access === null;
}

export {
  getAccessData,
  getIfAccessLoading,
  getIfHasAccess,
  getIfMeteredAccess,
  getIfNoAccess,
  getStoryCards,
  handleAccess,
  checkIfStoryPublic
};
